import { Button } from '../../../../../../components/Button'
import { LineData } from '../../../../../../components/LineData'
import { type ExpertDomain } from '../../../../../../types/domain/expert-domain'
import { getYesOrNoTextByBoolean } from '../../../../../../utils/getYesOrNoTextByBoolean'

interface Props {
  data?: ExpertDomain
  edit?: () => void
}

export const ProfessionalData = ({ data, edit }: Props) => {
  const handleProactiveText = () => {
    if (data?.professionalData?.proactive === 'no') {
      return 'Não'
    }

    if (data?.professionalData?.proactive === 'yesSearch') {
      return 'Sim, pesquisa'
    }

    if (data?.professionalData?.proactive === 'yesOffer') {
      return 'Sim, oferta'
    }

    return ''
  }

  const valueAndCurrency = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: data?.professionalData?.currency
      ? `${data?.professionalData?.currency}`
      : 'BRL',
  }).format(
    Number(
      typeof data?.professionalData?.value === 'string' &&
        data?.professionalData?.value
    )
  )

  return (
    <div>
      <div className="mb-4">
        <LineData label="Bio" text={data?.bio} />

        <LineData label="Observações" text={data?.observations} />
      </div>

      {/* Empresa Anterior */}
      <LineData
        label={'Empresa Anterior'}
        text={data?.professionalData?.previousCompany}
      />

      {/* Empresa atual */}
      <LineData
        label={'Empresa atual'}
        text={data?.professionalData?.currentCompany}
      />

      {/* Cargo */}
      <LineData label={'Cargo'} text={data?.professionalData?.position} />

      {/* Setor */}
      <LineData label={'Setor'} text={data?.professionalData?.sector} />

      {/* Subsetor */}
      <LineData label={'Subsetor'} text={data?.professionalData?.subsector} />

      {/* Área */}
      <LineData label={'Área'} text={data?.professionalData?.area} />

      {/* Moeda */}
      <LineData
        label={'Moeda'}
        text={data?.professionalData?.currency || 'Moeda não informada'}
      />

      {/* Valor */}
      <LineData
        label={'Valor'}
        text={valueAndCurrency || 'Valor não informado'}
      />

      {/* Small Group */}
      <LineData
        label={'Small Group'}
        text={
          data?.professionalData?.smallGroup === 'moreThan5'
            ? 'Mais de 5'
            : data?.professionalData?.smallGroup
        }
      />

      {/* Blind */}
      <LineData
        label={'Blind'}
        text={getYesOrNoTextByBoolean(data?.professionalData?.blind)}
      />

      {/* Proativo */}
      <LineData label={'Proativo'} text={handleProactiveText()} />

      <Button variant="outline" className="mt-10" onClick={edit}>
        Editar
      </Button>
    </div>
  )
}
